import TrackingAdapter from './TrackingAdapter';
import GARepository from './GARepository';

export type InteractionInputEvent = {
  pageElementName: string;
  pageSectionName: string;
  label: string;
  interactive?: boolean;
  additionalNodes?: Record<string, any>;
};

export type GaTracking = {
  trackInteraction: (eventData: InteractionInputEvent) => void;
  trackUserInteraction: (eventData) => void;
  trackFunnelEvent: (eventData) => void;
  trackCustomEvent: (eventName) => void;
};

export const gaTrackingFactory = (gaTrackingAdapter: TrackingAdapter, gaRepository: GARepository): GaTracking => ({
  trackInteraction(eventData: InteractionInputEvent) {
    const event = gaTrackingAdapter.toInteraction(eventData);
    gaRepository.send(event);
  },

  /**
   * @deprecated
   */
  trackUserInteraction(eventData) {
    const event = gaTrackingAdapter.toUserInteraction(eventData);
    gaRepository.send(event);
  },

  trackFunnelEvent(eventData) {
    const event = gaTrackingAdapter.toFunnelEvent(eventData);
    gaRepository.send(event);
  },

  trackCustomEvent(eventName) {
    const event = gaTrackingAdapter.toCustomEvent({ name: eventName });
    gaRepository.send(event);
  },
});
